import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-footStats-info"
}
const _hoisted_2 = { class: "as-footStats__info" }

import { computed } from "vue";
import type { IMatch } from "~src/interfaces";
import FootballTeamItem from "~src/components/foot_stats/FootballTeamItem.vue";
import type { IFootyStats } from "~src/interfaces/footystats";


const __default__ = {};

interface Props {
  match: IMatch;
  footyStats: IFootyStats | null;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FootballTeam',
  props: {
    match: {},
    footyStats: { default: null }
  },
  setup(__props: any) {

const props = __props;

const homePoint = computed<number>(() => {
  return props.footyStats?.pre_match_home_ppg ?? 0;
});

const awayPoint = computed<number>(() => {
  return props.footyStats?.pre_match_away_ppg ?? 0;
});

return (_ctx: any,_cache: any) => {
  return (_ctx.footyStats)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FootballTeamItem, {
            match: _ctx.match,
            mode: "info",
            footyStats: _ctx.footyStats,
            homePoint: homePoint.value,
            awayPoint: awayPoint.value
          }, null, 8, ["match", "footyStats", "homePoint", "awayPoint"]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "as-vs" }, "VS", -1)),
          _createVNode(FootballTeamItem, {
            match: _ctx.match,
            footyStats: _ctx.footyStats,
            modeTeam: "as-away",
            mode: "info",
            homePoint: homePoint.value,
            awayPoint: awayPoint.value
          }, null, 8, ["match", "footyStats", "homePoint", "awayPoint"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})